var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-tree',{ref:"refTree",attrs:{"data":_vm.data,"props":_vm.defaultProps,"node-key":_vm.nodeKey,"check-strictly":_vm.strongReleave,"default-checked-keys":_vm.defaultChecked,"show-checkbox":""},on:{"check":_vm.handleCheck}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }